import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  fetchArtistCaseStudy
} from '../artist-case-studies-container/actions'
import {
  getArtistCaseStudyRequestId
} from '../artist-case-studies-container/selectors'
import { 
  getArtistBioModules,
  getArtistPress
} from './selectors'
import {
  getViewportWidth
} from '../app/selectors'
import BioModule from '../artist-bio-module'
import PressModule from '../artist-press-module'
import './bio.css'

class Bio extends Component {
  
  componentDidMount() {
    // this.requestRows()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.active === this.props.active) return
    // this.requestRows()
  }

  // Request rows only if rows are empty
  // And active is set to true
  // Active is if route matches 
  requestRows() {
    const { requestId, id, modules, active, onRequestRows } = this.props

    if (!id) return
    if (modules && (requestId === id)) return
    if (!active) return
    
    onRequestRows && onRequestRows(id)
  }

  render() {
    const { modules, press, vw } = this.props

    return (
      <div className="bio">
        <div className="bio__modules">
          {modules && modules.map((moduleProps, index) => (
            <BioModule key={index} vw={vw} {...moduleProps} />
          ))}
        </div>
        <div className="bio__press">
          {press && press.map((pressProps, index) => (
            <PressModule key={index} {...pressProps} />
          ))}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    requestId: getArtistCaseStudyRequestId(state),
    vw: getViewportWidth(state),
    modules: getArtistBioModules(state),
    press: getArtistPress(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onRequestRows: id => {
      dispatch(fetchArtistCaseStudy(id))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Bio)



// WEBPACK FOOTER //
// ./src/components/artist-bio/index.js